import companyinfo from './companyinfo'
import member from './member'
import group from './group'
import tag from './tag'
import extra from './extra'
import itemManage from './itemManage'
import carryManage from './carryManage'
import fileConfig from './fileConfig'
import settingCommon from "./settingCommon";

const $api = Object.assign({},
    companyinfo,
    member,
    group,
    tag,
    extra,
    itemManage,
    carryManage,
    fileConfig,
    settingCommon
);
export default $api;


// WEBPACK FOOTER //
// ./src/service/company/index.js